
import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component
export default class MainTypeForm extends Vue {
  // ACTIONS
  @Action("actionCreateTypeForm", { namespace: "academy" })
  private actionCreateTypeForm: any;


  @Emit('on-next') 
  private onClickNext() {
    // TODO ON CLICK NEXT
  }

  private clickNext() {
    this.actionCreateTypeForm({
      success: (response: any) => {
        localStorage.setItem("id_type_form", response.id);
        this.onClickNext();
      },
    });
  }
}
